import { forwardRef } from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';
import type { TreeItemProps } from '@mui/x-tree-view-pro';

import type { ExtraItemProps } from '../../types';
import { CustomTreeItemStyled, stripExtraItemProps } from './CustomTreeItemStyled';

type LoadingPlaceholderItemProps = TreeItemProps & ExtraItemProps;

export const LoadingPlaceholderItem = forwardRef<HTMLLIElement, LoadingPlaceholderItemProps>(
  function LoadingPlaceholderItem(props, ref) {
    const treeItemProps = stripExtraItemProps(props);

    return (
      <CustomTreeItemStyled
        {...treeItemProps}
        ref={ref}
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.25 }}>
            <CircularProgress size={14} />
            <Typography variant='body2' color='text.secondary'>
              Loading…
            </Typography>
          </Box>
        }
      />
    );
  }
);
